import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-aside-menu',
  templateUrl: './layout-aside-menu.component.html',
  styleUrls: ['./layout-aside-menu.component.scss']
})
export class LayoutAsideMenuComponent {

  constructor() { }

}
